// Constants
import * as constants from "./constants";

export const defaultValue = () => ({
    [constants.PROPS_IS_PRIMARY]: true,
    [constants.PROPS_EMAIL]: {
        [constants.PROPS_EMAIL_ADDRESS]: "",
    },
});
